import { Component, OnInit } from '@angular/core';
import { EmptyLayout } from './layouts/empty/empty.component';
import { HorizontalLayout } from './layouts/horizontal/horizontal.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import {ActivatedRoute,  Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Event } from '@angular/router';
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, EmptyLayout, HorizontalLayout],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit {
  layout: string = 'empty';
  isLoading = true; // Loader flag
  constructor(private route: ActivatedRoute, private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
      } 
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {
   this._updateLayout()
  }

  private getCurrentRoute() {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot;
  }

  private _updateLayout(): void
  {
      // Get the current activated route
      let route = this.route;
      while ( route.firstChild )
      {
          route = route.firstChild;
      }

      const layoutFromQueryParam = route.snapshot.queryParamMap.get('layout');
      if ( layoutFromQueryParam ){
          this.layout = layoutFromQueryParam;
      }
      const paths = route.pathFromRoot;
      paths.forEach((path) =>
      {
          // Check if there is a 'layout' data
          if ( path.routeConfig && path.routeConfig.data && path.routeConfig.data['layout'] )
          {
              // Set the layout
              this.layout = path.routeConfig.data['layout'];
          }
      });
  }
}